import * as React from "react";
import { Link, useParams } from "react-router-dom";
import Attendance from "../index";
import UserProfile from "../..";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import RulesManagement from "./rulesManagement";
import { getUser } from "../../../../api/General/account";
import { UserView } from "../../../../models/general";
import { Skeleton } from "../../../../components/ui/Skeleton";

type Props = Readonly<{
    component?: React.ComponentType<any> | undefined;
    role?: any;
}>;

const Rules = (props: Props) => {
    const { id } = useParams();
    const [userInView, setUserInView] = useState<UserView>()
    const fetch = async () => {
        const user = await getUser(id as string);
        setUserInView(user.payload)
    }

    useEffect(() => {
        fetch()
    },[])

    return (
        <UserProfile>
            <Attendance>
                {userInView ? (
                    <RulesManagement userInView={userInView} refreshParent={fetch} />
                ) : (
                    <div className="space-y-4" aria-busy="true" aria-live="polite">
                        <Skeleton className="h-6 w-48 rounded" />
                        {Array.from({ length: 4 }).map((_, i) => (
                            <div key={i} className="bg-card border border-border rounded-xl p-6 space-y-3">
                                <Skeleton className="h-5 w-64 rounded" />
                                <Skeleton className="h-4 w-full rounded" />
                                <Skeleton className="h-4 w-3/4 rounded" />
                            </div>
                        ))}
                    </div>
                )}
            </Attendance>
        </UserProfile>
    );
};

export default Rules as any;
